<template>
  <v-container fluid>
    <SearchBar v-model="search" />
    <v-card outlined class="rounded-xl mt-5">
      <ListTitle
        title="Contacts"
        @new="$router.push({ path: '/contact/create' })"
      />

      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="contacts"
          :options.sync="options"
          :server-items-length="count"
          :loading="loading"
          class="table-header"
          :items-per-page="options.itemsPerPage"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
          }"
        >
          <template v-slot:item.fullName="{ item }">
            <span>{{ item.fullName }}</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  v-bind="attrs"
                  v-on="on"
                  class="ml-1"
                  small
                  color="#D0E9FF"
                  v-if="item.keytag"
                >
                  <v-icon small color="#3C4DA6">mdi-tag</v-icon>
                  <span>{{ item.keytag }}</span>
                </v-chip>
              </template>
              <span>Keytag</span>
            </v-tooltip>
          </template>

          <template v-slot:item.phoneNumber="{ item }">
            <span>{{ item.phoneNumber }}</span>
          </template>

          <template v-slot:item.email="{ item }">
            <span>{{ item.email }}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-menu bottom left offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list class="menu-button">
                <v-list-item @click="openProfile(item)">
                  <v-list-item-title>{{
                    $t("buttons.history")
                  }}</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="editContact(item)">
                  <v-list-item-title>{{
                    $t("buttons.edit")
                  }}</v-list-item-title>
                </v-list-item>
                <v-list-item @click="deleteContact(item)">
                  <v-list-item-title>{{
                    $t("buttons.delete")
                  }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import contactService from "../service";

export default {
  name: "contact-list",
  data() {
    return {
      search: null,
      contacts: [],
      count: 0,
      loading: false,
      rowsPerPageItems: [10, 25, 50, 100],
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        // other options if needed
      },
      headers: [
        { text: this.$t("labels.name"), value: "fullName" },
        { text: this.$t("labels.phoneNumber"), value: "phoneNumber" },
        { text: this.$t("labels.email"), value: "email" },
        { text: "", value: "action", sortable: false },
      ],
    };
  },
  watch: {
    search(val) {
      if (!val || val.length > 3) {
        this.getList();
      }
    },
    options: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    async getList() {
      this.loading = true;
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      const offset = (page - 1) * itemsPerPage;
      try {
        const response = await contactService.getAll({
          limit: itemsPerPage,
          offset,
          local: true,
          search: this.search,
          orderBy: [sortBy[0], sortDesc[0] ? "DESC" : "ASC"],
        });
        this.contacts = response.data;
        this.count = response.count;
      } catch (e) {
        console.error("Failed fetching contacts", e);
      } finally {
        this.loading = false;
      }
    },
    openProfile(contact) {
      this.$router.push({ path: `/contact/${contact.id}/profile` });
    },
    editContact(contact) {
      this.$router.push({ path: `/contact/${contact.id}/edit` });
    },
    deleteContact(contact) {
      this.$swal({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("Yes, delete it!"),
      }).then((result) => {
        if (result.value) {
          contactService.delete(contact.id).then(() => {
            this.$swal(
              this.$t("Deleted!"),
              this.$t("contact has been deleted."),
              "success"
            );
            this.getList();
          });
        }
      });
    },
  },
  created() {
    this.getList();
  },
};
</script>

<style scoped>
/* custom styles here */
</style>